import React from 'react'
import styles from '../../../index.module.scss'
import MapClient from './Client/index'

export type propsType = {
  data: any
  lang: any
  descStyle?: any
  mapModalTitle?: string
  done: string
}

export interface DialogTitleProps {
  id?: string
  children?: React.ReactNode
  onClose: () => void
}

const MapForClient = ({ data, lang, descStyle, mapModalTitle, done }: propsType) => {
  return (
    <section className={styles.map} id='WorkingLocation'>
      {lang.workingLocation && <h5>{lang.workingLocation}</h5>}
      <p style={descStyle}>{data?.addr || data?.address}</p>
      <MapClient data={data} mapModalTitle={mapModalTitle} done={done} />
    </section>
  )
}

export default MapForClient
